import { Injectable } from '@angular/core';
import {
  AbstractControlOptions,
  UntypedFormArray,
  Validators,
} from '@angular/forms';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';
import { CompanyFieldType } from '@app/forms/subscription/definition/interface/enum';
import {
  Parameters,
  PledgeProductRead,
} from '@app/forms/subscription/definition/interface/Pledge';
import { FormConfig } from '@app/forms/subscription/definition/types/subscription';
import FormGroupArray from '@app/forms/subscription/services/FormGroupArray';
import {
  getAdditionalQuestions,
  isFieldRequired,
} from '@app/forms/subscription/services/utile';

@Injectable({
  providedIn: 'root',
})
export abstract class EaSubscriptionBuilder extends PrFormAbstract {
  generateForm(entity: PledgeProductRead & { parameters: any }, option) {
    const { sessionConsultant } = option || {};
    let options: AbstractControlOptions = {};
    const parameters: Parameters = {
      ...option,
    };

    const formConfig: FormConfig<PledgeProductRead & { parameters: any }> = {
      id: [entity.id],
      type: [entity.type],
      productId: [entity.productId],
      productName: [entity.productName],
      status: [entity.status],
      parameters: this.formBuilder.group({
        investmentAmount: [
          entity?.parameters?.investmentAmount || null,
          Validators.required,
        ],
        taxReductionAmount: [
          entity?.parameters?.taxReductionAmount || null,
          sessionConsultant &&
          isFieldRequired(
            parameters,
            CompanyFieldType.DIVERSIFICATION_INVESTMENT_REDUCTION_AMOUNT,
          )
            ? Validators.required
            : Validators.nullValidator,
        ],
      }),
    };

    return this.formBuilder.group(formConfig, options);
  }
  generate(entity: any, option) {
    return FormGroupArray.generate({
      entity,
      options: option,
      formBuilder: this.formBuilder,
      generateForm: this.generateForm.bind(this),
      propertyName: 'products',
    });
  }

  dispalyQuestion(parameters: Parameters, type: any) {
    return getAdditionalQuestions(parameters, type);
  }

  get products() {
    return this.form.get('products') as UntypedFormArray;
  }

  extract() {
    return this.form.value.products;
  }
}
